import RoadsideAssistance from './RoadsideAssistance/RoadsideAssistance';

export async function generateMetadata() {
  return {
    title: 'Roadside Assistance | JAECOO',
    description:
      'Do you need help on the road? We provide 24/7 roadside assistance. Please, contact us:0330 159 0221. Visit the website:rac.co.uk/reportbreakdown.',
  };
}

const RoadsideAssistancePage = ({ fields }) => {
  // 安全的字段提取函数
  const getFieldValue = (field) => {
    if (field?.value !== undefined) {
      return field.value;
    }
    return typeof field === 'string' ? field : '';
  };

  // 映射Hero数据
  const heroData = {
    title: getFieldValue(fields?.heroText),
    image: fields?.heroImage,
  };

  // 映射NeedServicing数据
  const needServicingData = {
    title: getFieldValue(fields?.needTitle),
    text: getFieldValue(fields?.needContent),
    buttonText: getFieldValue(fields?.needButtonText),
    buttonUrl: fields?.needButtonUrl?.value?.href || getFieldValue(fields?.needButtonUrl),
    image: fields?.needImage,
  };

  // 映射RoadsideBlock数据
  const roadsideBlockData = {
    title: getFieldValue(fields?.roadTitle),
    text: getFieldValue(fields?.roadContent),
    termsText: getFieldValue(fields?.roadContent), // 条款文本包含在roadContent中
    termsUrl: fields?.roadButtonUrl?.value?.href || getFieldValue(fields?.roadButtonUrl),
    image: fields?.roadImage,
    buttonText: getFieldValue(fields?.roadButtonText),
  };

  // 映射ContactRoadside数据
  const contactRoadsideData = {
    title: getFieldValue(fields?.contactTitle),
    phoneLabel: getFieldValue(fields?.contactPhoneText),
    phoneNumber: getFieldValue(fields?.contactPhoneUrl),
    websiteLabel: getFieldValue(fields?.contactWeb),
    websiteUrl: fields?.contactWebUrl?.value?.href || getFieldValue(fields?.contactWebUrl),
    websiteText: getFieldValue(fields?.contactWebText),
    image: fields?.contactImage, // 现在contactImage是正确的图片对象
  };

  return (
    <div className="container">
      <RoadsideAssistance
        heroData={heroData}
        needServicingData={needServicingData}
        roadsideBlockData={roadsideBlockData}
        contactRoadsideData={contactRoadsideData}
      />
    </div>
  );
};

export default RoadsideAssistancePage;
